import { useEffect } from "react";

const SITE = "https://arstudiocreative.com";

export const useTitle = (title, description, canonicalPath = "/", keywords = "") => {
  useEffect(() => {
    document.title = title;

    const setMeta = (selector, attribute, value) => {
      if (!value) return;
      const element = document.querySelector(selector);
      if (element) element.setAttribute(attribute, value);
    };

    const canonical = SITE + canonicalPath;

    setMeta('meta[name="description"]', "content", description);
    setMeta('meta[name="keywords"]', "content", keywords);
    setMeta('meta[property="og:title"]', "content", title);
    setMeta('meta[property="og:description"]', "content", description);
    setMeta('meta[property="og:url"]', "content", canonical);
    setMeta('meta[name="twitter:title"]', "content", title);
    setMeta('meta[name="twitter:description"]', "content", description);

    const canonicalElement = document.querySelector('link[rel="canonical"]');
    if (canonicalElement) canonicalElement.setAttribute("href", canonical);
  }, [title, description, canonicalPath, keywords]);
};
